// extracted by mini-css-extract-plugin
export default {"root":"content_root__F3JGm","visible":"content_visible__TmAHF","list":"content_list__TBD-0","production":"content_production__-fd8i","paragraph-text":"content_paragraph-text__MVgOT"};